import React, { DOMAttributes } from "react";

type CustomEvents<K extends string> = { [key in K]: (event: CustomEvent) => void };
type CustomElement<T, K extends string> = Partial<
  T & DOMAttributes<T> & { children: any } & CustomEvents<`on${K}`>
>;
// eslint-disable-next-line
declare global {
  // eslint-disable-next-line
  namespace JSX {
    interface IntrinsicElements {
      ["web-header"]: CustomElement<any, "closeChange" | "openChange">;
    }
  }
}

const CustomHeader: React.FC<{
  customHeader: any;
}> = ({ customHeader }) => <>{customHeader ? <web-header data={JSON.stringify(customHeader)} /> : null}</>;

export default CustomHeader;
